import { TokenizedCards } from './TokenizedCards';

import { Button } from '@/components';
import usePinsAccount from '@/hooks/usePinsAccount';
import { CardKey, cn, formatNumberToLocale } from '@/utils';

interface Props {
  handleContinue: () => void;
  selectedCard: CardKey;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PayInOneInstallments = ({
  handleContinue,
  selectedCard,
}: Props) => {
  const { pinsData } = usePinsAccount();

  return (
    <div className={cn('flex flex-col space-y-4')}>
      <p className="text-center">
        Recordá que la operación puede demorar hasta 30 minutos en reflejarse.
      </p>
      {/* TOKENIZADAS */}
      <TokenizedCards key={selectedCard} selectedCard={selectedCard} />
      <div className="flex justify-between text-gdt-blue bg-gdt-blue-xl2 p-3 rounded-lg font-bold">
        <span>Importe a pagar </span>
        <span>
          {`$${formatNumberToLocale(
            pinsData.selectedProduct?.precio || pinsData.moneyToWallet || 0
          )}`}
        </span>
      </div>
      <Button type="button" variant="primary" onClick={handleContinue}>
        Confirmar
      </Button>
    </div>
  );
};
